import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "./components/zigzag";
import BeforeAfter from "./components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const DataCentersPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Data Center Cleaning Services - Flyby Shine</title>
                        <meta name="description" content="Specialized drone cleaning solutions for data centers. Maintain optimal operating conditions and extend equipment life with non-disruptive exterior cleaning." />
                        <meta name="keywords" content="Data Center Cleaning, Server Farm Maintenance, Mission Critical Facility Cleaning, IT Infrastructure Cleaning, Cooling System Cleaning, HVAC Exterior Maintenance, Data Center Drone Cleaning, Non-Disruptive Cleaning, Zero Downtime Cleaning" />
                        <meta property="og:image" content="/assets/datacenter.webp" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Data Center Cleaning Solutions'}
                    description={`Keep your mission-critical facility running at peak efficiency with our specialized data center exterior cleaning services.`}
                    banner={
                        {
                            image: '/assets/datacenter.webp',
                            alt: 'A drone cleaning a data center facility',
                        }
                    }
                    callToAction={<ButtonGroup>
                        <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request Work'} />
                        <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                    </ButtonGroup>}
                />


                <BeforeAfter
                    title={"Our Process"}
                    description={"We've refined our approach to data center cleaning to ensure maximum effectiveness with minimal risk."}
                    subTitle={"Data Center Exterior Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Comprehensive site assessment</li>
                                <li><i className="material-icons">check_circle_outline</i>Customized cleaning protocol</li>
                                <li><i className="material-icons">check_circle_outline</i>Non-disruptive implementation</li>
                                <li><i className="material-icons">check_circle_outline</i>Post-cleaning efficiency report</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/defensecbefore.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/defensecafter.png',
                        }

                    }
                    ]}
                />
                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/defensecafter.png', alt: 'Data center facility being cleaned by drone' }}
                        title={'Mission-Critical Cleaning'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'icon' }}
                        description={'Data centers house your most valuable digital assets, making regular maintenance essential yet challenging. Our drone technology enables thorough exterior cleaning of HVAC systems, cooling towers, and building facades without risking your operations or security protocols.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. We customize our approach to fit your specific requirements, ensuring optimal results for every job.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/monument.mp4',
                            thumbnail: '/assets/videos/thumbnails/monument.png'
                        }}
                        title={'Reduced Disruption Times'}
                        heading={{ image: '/assets/clock.svg', alt: 'faster bolt icon' }}
                        description={'Our drone-assisted cleaning services are faster and more efficient, allowing us to clean your property without disrupting your daily operations.'}
                    />

                </ZigZag>


                <Contact />
            </PageShell>

            <style jsx>{`

            .split-container {
            margin-top: 50px;
            margin-bottom: 50px;
            }
                .industry-specs-section {
                    background-color: #f8f9fa;
                    padding: 80px 0;
                    margin: 40px 0;
                }
                
                .specs-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 20px;
                }
                
                .specs-container h2 {
                    text-align: center;
                    margin-bottom: 50px;
                    color: var(--main-color);
                    font-size: 32px;
                }
                
                .specs-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                    gap: 30px;
                }
                
                .spec-item {
                    background-color: white;
                    padding: 25px;
                    border-radius: 8px;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                    transition: transform 0.3s ease;
                }
                
                .spec-item:hover {
                    transform: translateY(-5px);
                }
                
                .spec-item h3 {
                    color: var(--main-color);
                    margin-bottom: 15px;
                    font-size: 20px;
                }
                
                .spec-item p {
                    color: #555;
                    line-height: 1.6;
                    font-family: 'Open Sans', sans-serif;
                }
                
                @media (max-width: 768px) {
                    .specs-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>
        </>
    )
}

export default DataCentersPage
